import { ACC_TYPES, IPHONE_MODELS, WATTS, CONNECTORS, usesModels } from "@/lib/store";
import { chip } from "@/components/site/OrderSpecFields";

const Chips = ({ label, items, value, onPick, testid }) => (
  <div data-testid={testid}>
    <span className="mb-1.5 block text-xs text-zinc-400">{label}</span>
    <div className="flex flex-wrap gap-2">
      {items.map((it) => (
        <button type="button" key={it.id || "auto"} data-testid={`${testid}-${it.id || "auto"}`} aria-pressed={value === it.id} onClick={() => onPick(it.id)} className={chip(value === it.id)}>{it.label}</button>
      ))}
    </div>
  </div>
);

export const AccessoryFields = ({ form, setForm }) => {
  const compat = Array.isArray(form.compatible) ? form.compatible : [];
  const toggle = (m) =>
    setForm((f) => ({ ...f, compatible: compat.includes(m) ? compat.filter((x) => x !== m) : IPHONE_MODELS.filter((x) => x === m || compat.includes(x)) }));
  const setType = (t) => setForm((f) => ({ ...f, acc_type: t, compatible: usesModels(t) ? f.compatible : [], wattage: t === "fonte" ? f.wattage || WATTS[0] : "", connector: ["cabo", "loop"].includes(t) ? f.connector || "" : "" }));

  return (
    <div data-testid="accessory-fields" className="space-y-4 rounded-2xl border border-white/10 p-4">
      <Chips label="Tipo de acessório" testid="product-acc-type" items={ACC_TYPES.map((t) => ({ id: t.id, label: t.single }))} value={form.acc_type} onPick={setType} />
      {usesModels(form.acc_type) && (
        <div>
          <span className="mb-2 block text-xs text-zinc-400">Disponível para quais iPhones? ({compat.length} marcados)</span>
          <div className="grid max-h-48 grid-cols-2 gap-1.5 overflow-y-auto pr-1">
            {IPHONE_MODELS.map((m) => (
              <label key={m} className={`flex cursor-pointer items-center gap-2 rounded-lg border px-2.5 py-1.5 text-xs transition-colors ${compat.includes(m) ? "border-white bg-white text-black" : "border-white/10 text-zinc-200 hover:bg-white/5"}`}>
                <input type="checkbox" data-testid={`compat-${m.replace(/\s+/g, "-").toLowerCase()}`} checked={compat.includes(m)} onChange={() => toggle(m)} className="sr-only" />
                {m}
              </label>
            ))}
          </div>
        </div>
      )}
      {(form.acc_type === "cabo" || form.acc_type === "loop") && (
        <Chips label="Ponta que vai no iPhone" testid="product-connector" items={[{ id: "", label: "Automático pelo nome" }, ...CONNECTORS]}
          value={form.connector || ""} onPick={(connector) => setForm((f) => ({ ...f, connector }))} />
      )}
      {form.acc_type === "fonte" && (
        <Chips label="Potência" testid="product-wattage" items={WATTS.map((w) => ({ id: w, label: w }))} value={form.wattage} onPick={(wattage) => setForm((f) => ({ ...f, wattage }))} />
      )}
    </div>
  );
};
